<template>
	<div class="OrderDetails">
		<!-- pc页头 -->
		<TopHeader v-if="isPc" />
		<!-- mobile title -->
		<div class="topPart" v-else>
			<div class="return" @click="backPageFn"></div>
			<a href="https://m.tunnelling.cn/Manager/MemberIndex.aspx" v-if="isshowHeader"><img :src="imgUrl" /></a>
		</div>
		<!-- mobile-确认订单信息text -->
		<div class="mobile-order-title">
			{{ isPc ? '确认订单信息' : '购买详情' }}
		</div>
		<!-- 详情容器 -->
		<div class="details-container">
			<!-- pc-确认订单信息text -->
			<div class="pc-order-title">
				确认订单信息
			</div>
			<!-- 商品订单 -->
			<div class="goods-order">
				<!-- pc-单个商品订单 -->
				<div v-if="isPc" class="goods-order-box">
					<div class="order-box" v-for="(item, index) in orderGoodsData" :key="index">
						<!-- 封面图片 -->
						<router-link :to="{path:'/bookDetail', query:{InformationId:item.informationId}}" target="_blank" class="img-box">
							<img :src="item.informationImagePath" :onerror="defaultImg" />
						</router-link>
						<!-- 书的信息 -->
						<div class="c-wid-flex">
							<!-- 书及其实际价格 -->
							<div class="price-box c-box-flex">
								<router-link :to="{path:'/bookDetail', query:{InformationId:item.informationId}}" target="_blank" class="title c-wid-flex">{{ item.informationTitle }}</router-link>
								<div class="check-num c-wid-124" v-if="item.orderItems.length">{{ `已选 ${item.checkNum} 项` }}</div>
								<div class="actual-price c-wid-124"><span v-if="item.orderItems.length" class="text">共</span><span>{{ `¥${item.actualPrice}` }}</span></div>
							</div>
							<!-- 购买类型及已减价格 {{ item.buyType }} -->
							<div class="buy-type-box c-box-flex">
								<div class="buy-type c-wid-flex"></div>
								<div class="c-reduced-price c-wid-124" v-if="item.hasBeenReduced"><span>{{ `(已减¥${item.hasBeenReduced})` }}</span></div>
							</div>
							<!-- 书的章节及其价格 -->
							<div v-if="item.orderItems.length" class="chapter-box">
								<div class="chapters c-box-flex" v-for="(it, ind) in item.orderItems" :key="ind">
									<div class="title c-wid-flex">{{ it.informationContentTitle }}</div>
									<div class="price c-wid-124">{{ `¥${it.price}` }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- mobile-单个商品订单 -->
				<div v-else class="goods-order-box">
					<div class="order-box" v-for="(item, index) in orderGoodsData" :key="index">
						<div class="group-box">
							<!-- 封面图片 -->
							<router-link :to="{path:'/bookDetail', query:{InformationId:item.informationId}}" class="img-box">
								<img :src="item.informationImagePath" :onerror="defaultImg" />
							</router-link>
							<!-- 书的信息 -->
							<div class="info-box c-wid-flex">
								<!-- 书名 -->
								<div class="book-name-box c-box-flex">
									<router-link :to="{path:'/bookDetail', query:{InformationId:item.informationId}}" class="name">{{ item.informationTitle }}</router-link>
								</div>
								<!-- 已选项数 -->
								<div class="check-num-box">
									<span v-if="item.orderItems.length">{{ `已选 ${item.checkNum} 项` }}</span>
								</div>
								<!-- 购买类型及已减价格(弃用) -->
								<!-- <div class="buy-type-box">
									章节购买
									<div class="type-chapter" v-if="item.orderItems.length" @click="item.showChapter = !item.showChapter">
										<span>{{ item.buyType }}</span><i class="el-icon-arrow-down icon-arrow" :class="{'icon-arrow-rotate': item.showChapter}"></i>
									</div>
									全书购买
									<div class="type-all" v-else>{{ item.buyType }}</div>
								</div> -->
								<!-- 商品合计 -->
								<div class="goods-total-box c-box-flex">
									<div class="actual-pric"><span v-if="item.orderItems.length" class="text">共</span><span>{{ `¥${item.actualPrice}` }}</span></div>
									<div class="c-reduced-price" v-if="item.hasBeenReduced"><span>{{ `(已减¥${item.hasBeenReduced})` }}</span></div>
								</div>
							</div>
						</div>
						<!-- 书的章节及其价格 -->
						<div v-if="item.orderItems.length" class="chapter-box">
							<div class="chapters c-box-flex" v-for="(it, ind) in item.orderItems" :key="ind">
								<div class="title c-wid-flex">{{ it.informationContentTitle }}</div>
								<div class="price">{{ `¥${it.price}` }}</div>
							</div>
							<!-- 带有展开收起功能(弃用) -->
							<!-- <el-collapse-transition>
								<div v-show="item.showChapter">
									<div class="chapters c-box-flex" v-for="(it, ind) in item.orderItems" :key="ind">
										<div class="title c-wid-flex">{{ it.informationContentTitle }}</div>
										<div class="price">{{ `¥${it.price}` }}</div>
									</div>
								</div>
							</el-collapse-transition> -->
						</div>
					</div>
				</div>
			</div>
			<!-- 合计 -->
			<div class="total-price-box c-box-flex">
				<span class="text">合计：</span>
				<div class="price">{{ `¥${totalPrice}` }}<span>元</span></div>
			</div>
			<!-- 支付方式 -->
			<div class="payment-method-box">
				<div class="text">支付方式</div>
				<div class="method-box">
					<div v-if="!disabledAilpay" class="Ailpay" :class="{'SelectLight': AilpayWay === 1}">
						<el-radio v-model="AilpayWay" :label="1">支付宝支付</el-radio>
					</div>
					<div class="wechat" :class="{'SelectLight': AilpayWay === 2}">
						<el-radio v-model="AilpayWay" :label="2">微信支付</el-radio>
					</div>
				</div>
			</div>
			<!-- 确认下单 -->
			<div class="confirm-order-btn">
				<!-- <div v-loading="loading" @click="ConfirmOrderFn">确认下单</div> -->
				<el-button type="primary" :loading="loading" @click="ConfirmOrderFn">确认下单</el-button>
			</div>
		</div>
		<!-- 页脚 -->
		<BottomFooter v-if="isPc" />
	</div>
</template>

<script>
	import TopHeader from '../../components/TopHeader.vue'
	import BottomFooter from '@/components/BottomFooter.vue'
	export default {
		name: 'OrderDetails',
		data() {
			return {
				orderGoodsData: [],  // 订单信息列表
				AilpayWay: 1,  // 支付方式
				totalPrice: 0,  // 合计
				loading: false,  // 按钮加载状态（支付接口调起中）
				disabledAilpay: false,  // 支付宝方式是否禁用（在微信浏览器里会禁用）
				wxPayParams: undefined,  // 微信接口返回的参数
				isPc: true,
				imgUrl: '',
				isshowHeader: true,
				goodsIds: [],
				defaultImg: 'this.src="' + require('../../assets/img/default_pic.png') + '"'  // 默认封面
			}
		},
		components: {
			TopHeader,
			BottomFooter
		},
		created() {
			// 判断加载哪个dom
			let wid = window.innerWidth;
			if (wid >= 320 && wid <= 1024) {
				this.isPc = false;
			}
		},
		mounted() {
			// 页面回到顶部
			let whichBrowser = this.myBrowser();
			if(whichBrowser === 'Chrome') {
				// chrome
				document.body.scrollTop = 0
			}else if(whichBrowser === 'FF') {
				// firefox
				document.documentElement.scrollTop = 0
			}else if(whichBrowser === 'Safari') {
				// safari
				window.pageYOffset = 0
			}else {
				document.body.scrollTop = 0;
			}
			// 获取用户信息
			this.GetUserInfo()
			
			// 获取订单信息
			let orderInfo = JSON.parse(sessionStorage.getItem('zhishi_OrderGoods'));
			if(!orderInfo) return
			
			this.orderGoodsData = orderInfo.goods
			this.totalPrice = orderInfo.totalPrice
			this.getGoodsIdsFn()
			
			// 获取微信授权码
			let code = this.GetQueryString('code');
			this.JugeWx(code);
		},
		methods: {
			// 判断浏览器
			myBrowser() {
			    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
			    var isOpera = userAgent.indexOf("Opera") > -1;
			    if (isOpera) {
			        return "Opera"
			    }; //判断是否Opera浏览器
			    if (userAgent.indexOf("Firefox") > -1) {
			        return "FF";
			    } //判断是否Firefox浏览器
			    if (userAgent.indexOf("Chrome") > -1){
					return "Chrome";
				} //判断是否Chrome浏览器
			    if (userAgent.indexOf("Safari") > -1) {
			        return "Safari";
			    } //判断是否Safari浏览器
			    if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
			        return "IE";
			    }; //判断是否IE浏览器
			},
			// 获取用户信息
			GetUserInfo() {
				this.$fetch('/Login')
				.then((res)=>{
					if(res.data.accessAllowed === false){
						this.isshowHeader = false;
						return;
					}
					this.imgUrl = res.data.imagePath;
				}).catch((err)=>{
					throw err;
				});
			},
			// 获取商品id
			getGoodsIdsFn() {
				let goodIds = []
				this.orderGoodsData.forEach(item => {
					if(item.goodsId) {
						goodIds.push(item.goodsId)
					}
					item.orderItems.forEach(child => {
						goodIds.push(child.goodsId)
					})
				});
				this.goodsIds = goodIds;
			},
			// 确认下单
			ConfirmOrderFn() {
				this.loading = true
				
				// 正常浏览器和微信浏览器支付方式调用接口不同 所以会判断
				if(!this.disabledAilpay) {
					this.PcPayWay();
					return;
				}
				this.WeChatFn();
			},
			// pc支付方式
			PcPayWay(){
				let way = this.AilpayWay === 1 ? '支付宝' : '微信';
				// let successUrl = this.isPc ? 'https://www.tunnelling.cn/PMember/MyBookList.aspx' : 'https://zhishi.tunnelling.cn/#/mybooklist'
				let params = {
					"goodsIds": this.goodsIds,
					"PaymentWay": way,
					"SucceededUrl": `${Const_Api_Root}/index.html#/paySuccess`,
				  "FailedUrl": `${Const_Api_Root}/index.html#/payError`
				};
				// "CouponId": "88afdff4-a6fb-4ae7-ah9b-5f51e162078e",  优惠券id(暂无该功能)
				
				this.$post('/api/payment', params).then((res) => {
					// 判断会员是否登录
					if(res.data && res.data.accessAllowed === false) {
						this.LoginTip();
						return
					}
					// 存储是在购物车支付的页面
					sessionStorage.setItem('isCart', 'cart');
					
					if(res.data.generated){
						if(res.data.form){
							document.write(res.data.form);
							return;
						}
						
						// 删除本地存储
						sessionStorage.removeItem('zhishi_OrderGoods')
						location.href = res.data.payUrl ? res.data.payUrl : params.SucceededUrl;
					}else{
						this.$message.error(res.data.message);
					}
				}).catch((err)=>{
					throw err;
				});
			},
			// 微信浏览器
			WeChatFn(){
				let code = this.GetQueryString('code'); // 获取微信授权码
				code = code ? code : ''; // code为undefined传空字符串
				let url = Const_Api_Root + "/wx_redirect.html";
				
				let params = {
					"goodsIds": this.goodsIds,
					"code": code, // 授权码
					"redirectUrl": encodeURIComponent(url), // 授权后重定向的页面
					"state": encodeURIComponent(location.hash),
					"paymentWay": "微信",
					"SucceededUrl": `${Const_Api_Root}/index.html#/paySuccess`,
					"FailedUrl": `${Const_Api_Root}/index.html#/payError`
				};
				this.$post('/api/payment', params).then((res)=>{
					// 授权地址不为空跳转到授权页面
					if (!code && res.data.authorizationUrl) {
					    location.href = res.data.authorizationUrl;
					    return;
					}
					
          if(!res.data.payUrl) {
            location.href = `${Const_Api_Root}/index.html#/paySuccess?orderInfoId=${this.payId}&isCart=cart`;
            return;
          }
					// 得到jsapi的参数
					this.wxPayParams = res.data.jsApiParameters;
					// 调起微信浏览器支付
					this.CallPay();
				}).catch((err)=>{
					throw err;
				});
			
			},
			// 微信支付的回调函数
			CallPay() {
			    if (typeof WeixinJSBridge == "undefined") {
			        if (document.addEventListener) {
			            document.addEventListener('WeixinJSBridgeReady', this.JsApiCall, false);
			        } else if (document.attachEvent) {
			            document.attachEvent('WeixinJSBridgeReady', this.JsApiCall);
			            document.attachEvent('onWeixinJSBridgeReady', this.JsApiCall);
			        }
			    } else {
			        this.JsApiCall();
			    }
			},
			//调用微信JS api 支付
			JsApiCall() {
				// get_brand_wcpay_request:ok	支付成功
				// get_brand_wcpay_request: cancel	支付过程中用户取消
				// get_brand_wcpay_request: fail	支付失败
				
			    WeixinJSBridge.invoke('getBrandWCPayRequest', JSON.parse(this.wxPayParams),
			        (res) => {
						// 支付回调
			            switch (res.err_msg) {
			                case 'get_brand_wcpay_request:ok':
								this.WxPayFn(true);
			                    break;
			                case 'get_brand_wcpay_request:cancel':
			                    this.WxPayFn(false);
			                    break;
			                case 'get_brand_wcpay_request:fail':
			                    this.WxPayFn(false);
			                    break;
			                default:
			                    this.WxPayFn(false);
			                    break;
			            }
			        }
			    );
			},
			// 微信浏览器支付后fn
			WxPayFn(type){
				// 删除本地存储
				sessionStorage.removeItem('zhishi_OrderGoods')
				
				if(type) {
					location.href = `${Const_Api_Root}/index.html#/paySuccess?orderInfoId=${this.payId}&isCart=cart`
				}else {
					location.href = Const_Api_Root + "/index.html#/payError"
				}
			},
			// 获取链接地址上的参数
			GetQueryString(name) {
				var result = location.href.match(new RegExp("[\?\&]" + name+ "=([^\&]+)","i"));
				if(result == null || result.length < 1){
					return "";
				}
				return result[1];
			},
			// 判断是否是微信浏览器
			JugeWx(code){
				var ua = navigator.userAgent.toLowerCase();
				if(ua.match(/MicroMessenger/i)=="micromessenger") {
					this.AilpayWay = 2;
					this.disabledAilpay = true;
			        if(code) return
			        this.WeChatFn()
				} else {
					this.AilpayWay = 1;
				}
			},
			// 未登录提示
			LoginTip() {
			    this.$confirm('登录状态失效，请重新登录下单，是否继续？', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
			    }).then(() => {
			        let nowHref = `${Const_Api_Root}/#/myCart`;
			        let href = 'https://www.tunnelling.cn/PMember/MemberLogin.aspx?returnUrl=' + encodeURIComponent(nowHref);
			        location.href = href;
			    }).catch(() => {});
			},
			// 页面返回
			backPageFn() {
				this.$router.go(-1)
			}
		}
	}
</script>

<style scoped>
	/* 移动端 */
	@media screen and (min-width: 320px) and (max-width: 1024px) {
		/* 返回 */
		.topPart{
			width: 100%;
			height: .88rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 .24rem;
		}
		
		.topPart img{
			width: .6rem;
			height: .6rem;
			border-radius: 50%;
		}
		
		.topPart .return{
			width: .4rem;
			height: .4rem;
			background: url(../../assets/img/return_mobile.svg) no-repeat;
			background-size: 100% 100%;
		}
		
		/* 确认下单 */
		.confirm-order-btn>div {
			width: 100%;
			height: .88rem;
			line-height: .88rem;
			background: linear-gradient(90deg, #3A69E9 0%, #3A95E9 100%);
			border-radius: .08rem;
			margin-top: .48rem;
		}
		
		/* 支付方式 */
		.payment-method-box {
			background: #FFFFFF;
			border-radius: .08rem;
			padding: .24rem .2rem;
		}
		
		.payment-method-box .text {
			font-size: .36rem;
			font-weight: 600;
			color: #333333;
			margin-bottom: .28rem;
		}
		
		.method-box .Ailpay {
			margin-bottom: .24rem;
		}
		
		.method-box .Ailpay, .method-box .wechat {
			width: 100%;
			border-radius: .08rem;
			border: 1px solid transparent;
			background: #F3F5F8;
		}
		
		.method-box .SelectLight {
			border: 1px solid #3A69E9;
			background-color: #FFFFFF;
		}
		
		.method-box label {
			line-height: .88rem;
			padding: 0 .2rem;
			display: flex;
			align-items: center;
			flex-direction: row-reverse;
			justify-content: space-between;
		}
		
		/* 合计 */
		.total-price-box {
			padding: .22rem .2rem;
			justify-content: space-between;
			margin: .24rem 0;
			background-color: #FFFFFF;
			border-radius: .08rem;
		}
		
		.total-price-box .text {
			font-size: .36rem;
			font-weight: 600;
			color: #333333;
		}
		
		.total-price-box .price {
			font-size: .4rem;
			font-weight: 600;
			color: #FC6B21;
		}
		
		.total-price-box .price>span {
			display: none;
			font-size: 16px;
			font-weight: 400;
			color: #656565;
			margin-left: 8px;
		}
		
		/* 商品列表 */
		.order-box {
			background-color: #FFFFFF;
			padding: .2rem;
			border-radius: .08rem;
			margin-bottom: .2rem;
		}
		
		.group-box {
			display: flex;
		}
		
		/* 书的封面 */
		.group-box .img-box{
			display: block;
			width: 1.4rem;
			height: 1.88rem;
			margin-right: .16rem;
		}
		
		.group-box .img-box img {
			width: 100%;
			height: 100%;
		}
		
		/* 书的信息 */
		.info-box {
			width: calc(100% - 1.56rem);
		}
		
		/* 书名 */
		.book-name-box .name {
			width: 100%;
			font-size: .32rem;
			font-weight: 500;
			color: #333333;
			overflow:hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow:ellipsis;
		}
		
		/* 已选项数 */
		.check-num-box {
			margin: 0.3rem 0 0.22rem;
			font-size: 14px;
			min-height: 14px;
			font-weight: 400;
			color: #333333;
		}
		
		/* 购买方式 */
		.buy-type-box {
			margin: .12rem 0 .5rem;
		}
		
		.buy-type-box .type-chapter {
			width: 1.68rem;
			height: .48rem;
			line-height: .48rem;
			text-align: center;
			background: #3A69E9;
			border-radius: .04rem;
			color: #FFFFFF;
			font-weight: 400;
			font-size: .28rem;
		}
		
		.buy-type-box .type-chapter>span {
			margin-right: .08rem;
		}
		
		.buy-type-box .type-all {
			width: 1.36rem;
			height: .48rem;
			line-height: .48rem;
			text-align: center;
			background: #F0F0F0;
			border-radius: .04rem;
		}
		
		.icon-arrow {
			/*设置所有动画的效果：0.3s 淡出效果*/
			transition: all .3s ease-out;
		}
		
		.icon-arrow-rotate {
		    /*旋转180度*/
		    transform: rotate(180deg);
		}
		
		/* 商品合计 */
		.goods-total-box .actual-pric {
			font-size: .32rem;
			font-weight: 600;
			color: #333333;
			margin-right: .2rem;
		}
		
		.goods-total-box .actual-pric .text {
			font-size: 14px;
			font-weight: 400;
			color: #333333;
			margin-right: 8px;
		}
		
		/* 章节 */
		.chapter-box .chapters {
			font-size: .28rem;
			font-weight: 400;
			color: #333333;
			padding: .2rem 0;
			border-bottom: 1px solid #EFEFEF;
		}
		
		.chapter-box .title {
			font-size: .28rem;
			font-weight: 400;
			overflow:hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow:ellipsis;
		}
		
		.chapter-box .price {
			margin-left: .3rem;
		}
		
		/* 购物车text */
		.details-container {
			background-color: #F8F8F8;
			padding: .24rem;
		}
		
		.details-container .pc-order-title {
			display: none;
		}
		
		.mobile-order-title {
			height: .88rem;
			line-height: .88rem;
			background: #FFFFFF;
			padding: 0 .24rem;
			font-size: .36rem;
			font-weight: bold;
			color: #333333;
		}
		
		.check-all-box {
			height: 48px;
		}
		
		.all-checkbox .goods-text {
			margin-left: 26px;
		}
		
		/* 公共样式 */
		.c-small-text {
			font-size: .28rem;
			font-weight: 400;
			color: #696969;
		}
		
		.c-box-flex {
			display: flex;
			align-items: center;
		}
		
		.c-wid-124 {
			width: 124px;
			text-align: right;
		}
		
		.c-wid-flex {
			flex: 1;
		}
		
		.c-reduced-price span {
			padding: 1px 4px;
			border-radius: 4px;
			opacity: 0.8;
			border: 1px solid #3A69E9;
			font-size: 12px;
			font-weight: 400;
			color: #3A69E9;
		}
	}
	
	/* pc端 */
	@media screen and (min-width: 1029px) {
		.OrderDetails {
			background-color: #F6F6F6;
			border-radius: 4px;
		}
		
		/* 确认下单 */
		.confirm-order-btn {
			display: flex;
			justify-content: flex-end;
			padding-bottom: 20px;
		}
		
		.confirm-order-btn>div {
			width: 222px;
			height: 56px;
			background: #3A69E9;
			border-radius: 4px;
			opacity: 1;
			font-size: 22px;
			font-weight: 500;
			color: #FFFFFF;
			line-height: 56px;
			text-align: center;
			cursor: pointer;
		}
		
		/* 支付方式 */
		.payment-method-box .text {
			font-size: 20px;
			font-weight: 600;
			color: #3A3A3A;
		}
		
		.method-box {
			padding: 20px 0;
			background-color: #FFFFFF;
			border-radius: 12px;
		}
		
		.method-box .Ailpay, .method-box .wechat {
			width: 100%;
			border-radius: 8px;
			border: 1px solid #E1E1E1;
		}
		
		.method-box .wechat {
			margin-top: 20px;
		}
		
		.method-box .SelectLight {
			border: 2px solid #2468F2;
		}
		
		.method-box label {
			line-height: 80px;
			padding: 0 20px;
			display: flex;
			align-items: center;
			flex-direction: row-reverse;
			justify-content: space-between;
		}
		
		/* 合计 */
		.total-price-box {
			padding: 12px 0;
			justify-content: space-between;
			margin: 14px 0;
		}
		
		.total-price-box .text {
			font-size: 18px;
			font-weight: 400;
			color: #929292;
			margin-right: 18px;
		}
		
		.total-price-box .price {
			font-size: 24px;
			font-weight: 500;
			color: #EB5757;
			margin-bottom: 5px;
		}
		
		.total-price-box .price>span {
			font-size: 16px;
			font-weight: 400;
			color: #656565;
			margin-left: 8px;
		}
		
		/* 商品列表 */
		.order-box {
			display: flex;
			padding: 20px;
			border: 1px solid #E1E1E1;
			margin-bottom: 20px;
		}
		
		.order-box:last-child {
			margin-bottom: 0;
		}
		
		/* 图片 */
		.img-box {
			display: block;
			width: 106px;
			height: 142px;
			margin-right: 14px;
		}
		
		.img-box img {
			width: 100%;
			height: 100%;
		}
		
		/* 商品信息--书名 */
		.price-box {
			margin-top: 3px;
		}
		
		.price-box .title {
			font-size: 16px;
			font-weight: 500;
			color: #3A3A3A;
		}
		
		.price-box .check-num {
			font-size: 14px;
			font-weight: 400;
			color: #929292;
		}
		
		.price-box .actual-price {
			font-size: 19px;
			font-weight: 600;
			color: #3A3A3A;
		}
		
		.price-box .actual-price .text {
			font-size: 15px;
			font-weight: 400;
			margin-right: 6px;
			color: #929292;
		}
		
		/* 购买类型 */
		.buy-type-box {
			margin: 8px 0 17px;
		}
		
		.buy-type-box .buy-type {
			font-size: 16px;
			font-weight: 400;
			color: #929292;
		}
		
		/* 章节 */
		.chapter-box {
			position: relative;
		}
		
		.chapter-box .chapters {
			width: 100%;
			margin-bottom: 12px;
		}
		
		.chapter-box .chapters .title {
			font-size: 14px;
			font-weight: 400;
			color: #3A3A3A;
		}
		
		.chapter-box .chapters .price {
			font-size: 16px;
			font-weight: 400;
			color: #656565;
		}
		
		.chapter-box .chapters .handle-btn span {
			position: absolute;
			right: 0;
			top: 50%;
			transform: translateY(-50%);
		}
		
		/* 购物车text */
		.details-container {
			width: 1200px;
			margin: 14px auto;
			background: #FFFFFF;
			box-sizing: border-box;
			padding: 0 20px;
		}
		
		.details-container .pc-order-title {
			font-size: 20px;
			font-weight: 600;
			color: #3A3A3A;
			padding: 20px 0;
		}
		
		.mobile-order-title {
			display: none;
		}
		
		.check-all-box {
			height: 48px;
		}
		
		.all-checkbox .goods-text {
			margin-left: 26px;
		}
		
		/* 公共样式 */
		.c-small-text {
			font-size: 16px;
			font-weight: 400;
			color: #656565;
		}
		
		.c-box-flex {
			display: flex;
			align-items: center;
		}
		
		.c-wid-124 {
			width: 124px;
			text-align: right;
		}
		
		.c-wid-flex {
			flex: 1;
		}
		
		.c-reduced-price span {
			padding: 3px 4px;
			border-radius: 4px;
			opacity: 0.8;
			border: 1px solid #3A69E9;
			font-size: 12px;
			font-weight: 400;
			color: #3A69E9;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/MyCart/ConfirmOrder.vue